<app-popover #popover class="notification-popover" contentId="notification-popover-content" placement="bottom-right">
  <app-nav-tab
    #trigger
    popover-trigger
    [tabs]="triggerTabs()"
    [appFeatureOnboarding]="NOTIFICATION_CENTER_ONBOARDING"
    (discover)="discover()"
  />
  <app-notification-center
    presentation="popover"
    role="dialog"
    aria-labelledby="notification-popover-title"
    [unread]="notifications.unread()"
    [read]="notifications.read()"
    [tab]="activeTab()"
    [loading]="notifications.loading()"
    [error]="notifications.hasError()"
    [markingAllAsRead]="notifications.markingAllAsRead()"
    (tabChange)="activeTab.set($event)"
    (markAllAsRead)="notifications.markAllAsRead()"
    (retry)="notifications.reload()"
    (open)="open($event, popover)"
    (openCenter)="popover.close()"
  />
</app-popover>
